import { useEffect, useState } from "react";

import { type DisplayModePreference, resolveIsWideScreen } from "~/helpers/displayModePreference";
import { isAnyGuardArmed, subscribeToLastGuardDisarm } from "~/hooks/useUnsavedChangesGuard";

const useEffectiveIsWideScreen = (preference: DisplayModePreference, defaultThreshold: number): boolean => {
	const { autoThresholdPx, mode } = preference;
	const isWindowWide = () => resolveIsWideScreen(window.innerWidth, preference, defaultThreshold);
	const [isWideScreen, setIsWideScreen] = useState(isWindowWide);
	const [guardReleases, setGuardReleases] = useState(0);
	const followWindow = () => {
		if (!isAnyGuardArmed()) setIsWideScreen(isWindowWide());
	};

	useEffect(() => subscribeToLastGuardDisarm(() => setGuardReleases((count) => count + 1)), []);

	useEffect(() => {
		setIsWideScreen(isWindowWide());
		window.addEventListener("resize", followWindow);
		window.addEventListener("orientationchange", followWindow);
		return () => {
			window.removeEventListener("resize", followWindow);
			window.removeEventListener("orientationchange", followWindow);
		};
	}, [mode, autoThresholdPx, defaultThreshold]);

	useEffect(followWindow, [guardReleases]);

	return isWideScreen;
};

export default useEffectiveIsWideScreen;
